module.exports = __webpack_public_path__ + "img/hour-glass.34e93ad2.svg";